/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import BASEURL from "../config.js";

function _getCookieValue(key) {
    const name = `happay.${key}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            const value = c.substring(name.length, c.length);
            return value;
        }
    }

    return "";
}

const subDomain = window.location.hostname.split(".")[0];
if (window.location.hash.indexOf("#") === 0) {
    window.location = window.location.hash.substring(1);
} else {
    const { pathname } = window.location;
    const queryKey = window.location.search;
    const nonSSO = [
        "local",
        "v2",
        "expense",
        "vendor",
        "localhost",
        "travel",
        "v2-uat",
        "expense-uat",
        "v2-prep",
        "expense-prep",
        "dev-icici-prep-crd",
        "v2-new-ui",
        "segfault1",
        "v2-nui-prep"
    ];

    if (
        subDomain &&
        nonSSO.indexOf(subDomain) === -1 &&
        queryKey.indexOf("logout") === -1 &&
        !pathname.includes("/login/verifyemail/") &&
        !_getCookieValue("cid")
    ) {
        const url = `${BASEURL}access/v2/sso/?domain=${subDomain}`;
        var http = new XMLHttpRequest();
        http.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                // eslint-disable-next-line no-debugger
                // debugger;
                const urls = unescape(decodeURIComponent(pathname + queryKey)); // decodeURIComponent(window.location.hash);
                const urlArr = urls ? urls.split("?") : [];

                // filtering the hash key generated due to history
                const queryArr =
                    (urlArr[1] && urlArr[1].split("&").filter(q => !q.startsWith("_"))) || [];

                if (queryArr && queryArr.length && urlArr[1].indexOf("c_code") === -1) {
                    queryArr.splice(queryArr.length, 0, "c_code=+91");
                }

                if (queryArr && queryArr.length && urlArr[1].indexOf("hasRole") === -1) {
                    queryArr.splice(queryArr.length, 0, "hasRole=false");
                }

                const urlObj = {};
                const initialPartOfURL = urlArr[0];
                // var queryPartOfURL = queryArr.join("&");

                if (queryKey.indexOf("user") !== -1 && queryKey.indexOf("userId") !== -1) {
                    for (const key in queryArr) {
                        const tempArray = queryArr[key].split("=");
                        const name = tempArray[0];
                        let value = tempArray[1];

                        if (name === "c_code" && !value) {
                            value = "+91";
                        }
                        if (!urlObj.hasOwnProperty(name)) {
                            urlObj[name] = {};
                        }
                        urlObj[name] = value;
                    }
                }

                // if (urlArr && urlArr.length) {
                //     const redirectUrl = initialPartOfURL + queryKey;
                //     localStorage.setItem("isSSO", true);
                //     if (redirectUrl !== "/" && redirectUrl !== "/login") {
                //         localStorage.setItem("redirectUrl", redirectUrl);
                //         if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
                //             localStorage.setItem("urlObj", JSON.stringify(urlObj));
                //         }
                //     }
                // }

                let dt = { redirect_url: "" };
                try {
                    dt = JSON.parse(this.response);
                } catch (err) {
                    console.log(err);
                }
                if (dt.redirect_url) {
                    window.location = dt.redirect_url;
                }
            } else if (this.readyState === 4 && this.status > 399) {
                try {
                    const dt = JSON.parse(this.response);
                    console.log(dt);
                } catch (err) {
                    console.log(err);
                }
            }
        };
        http.open("GET", url, true);
        http.send();
    }
}
